import React from 'react';

/**
 * The ×N corner badge on a stacked item. Shared by the bag grid and the combat Use
 * Item popover so a stack is recognisable as the same thing in both places; it is
 * absolutely positioned, so its host needs `position: relative`.
 */
export const StackBadge: React.FC<{ quantity: number }> = ({ quantity }) => {
  if (quantity <= 1) return null;

  return (
    <span style={{
      position: 'absolute',
      bottom: 2,
      left: 3,
      padding: '0 3px',
      background: 'rgba(10, 25, 40, 0.9)',
      border: '1px solid #3a6a9a',
      borderRadius: 3,
      color: '#cfe6ff',
      fontSize: 9,
      lineHeight: '13px',
      fontFamily: 'monospace',
      pointerEvents: 'none',
    }}>
      ×{quantity}
    </span>
  );
};
